import type {FC, ReactNode} from 'react';
import {Theme} from '@wellstone-solutions/common';
import {Box, Chip, Stack, Typography} from '@wellstone-solutions/web';
import {getAdminRole} from 'utils/Forms';

interface DirectoryOption {
  id: string;
  name: string;
  role?: string;
  user?: {id: string; email?: string};
}

interface RoleChipOptionProps {
  label: ReactNode;
  option: DirectoryOption;
}

export const RoleChipOption: FC<RoleChipOptionProps> = ({label, option}) => {
  const role = getAdminRole(option.role) ?? {name: 'Patient'};

  return (
    <Stack
      direction="row"
      justifyContent="space-between"
      alignItems="center"
      py={1}
      flex={1}>
      <Box data-testid="directory-search-option">
        <Typography variant="body1">{label}</Typography>
      </Box>
      <Box>
        <Chip
          label={role.name}
          variant="default"
          size="small"
          sx={{
            backgroundColor: Theme.colorPalette.secondary3,
            color: Theme.colorPalette.onSecondary,
          }}
          data-testid="directory-search-role-chip"
        />
      </Box>
    </Stack>
  );
};
